import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { server } from "../server";

export const fetchDuesFeeDetails = createAsyncThunk(
  "duesFee/fetchDuesFeeDetails",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(`${server}/due_fee_mongodb`, {
        headers: {
          Authorization: `${localStorage.getItem("token")}`,
        },
      });

      const parsedData = JSON.parse(response.data?.["body-json"]?.body || "{}");

      if (parsedData?.data) {
        return parsedData.data;
      } else {
        console.error("Invalid data format from API", response.data);
        return thunkAPI.rejectWithValue("Invalid data format");
      }
    } catch (error) {
      console.error("Error fetching dues fee details:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const duesFeeSlice = createSlice({
  name: "duesFee",
  initialState: {
    data: [],
    loading: true,
    error: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDuesFeeDetails.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(fetchDuesFeeDetails.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchDuesFeeDetails.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export default duesFeeSlice.reducer;
